module.exports = __webpack_public_path__ + "img/g790_rotated.cd3c9e03.png";